import { asyncSimpleModal } from '../common';

/**
 *  원격 이미지 비활성화 처리 시 확인 모달
 */
export const remoteImageInActiveConfirm = async ({ remoteImageTypeName }) => {
  const confirmResult = await asyncSimpleModal({
    type: 'confirm',
    title: '비활성화하기',
    message: `비활성화하면 App에서 ${remoteImageTypeName} 이미지가 노출되지 않습니다.\n해당 ${remoteImageTypeName} 이미지를 비활성화 하시겠습니까?`,
  });

  return confirmResult;
};

/**
 *  원격 이미지 활성화 처리 시 확인 모달
 */
export const remoteImageActiveConfirm = async ({ remoteImageTypeName }) => {
  const confirmResult = await asyncSimpleModal({
    type: 'confirm',
    title: '활성화하기',
    message: `활성화하면 이외의 ${remoteImageTypeName} 이미지는 모두 비활성화 처리됩니다.\n해당 ${remoteImageTypeName} 이미지를 활성화 하시겠습니까?`,
  });

  return confirmResult;
};
